module.exports = __webpack_public_path__ + "img/easterEgg.02058fa5.jpg";